<template>
  <el-row :gutter="15" v-show="!isEmpty(moduleData) || !isEmpty(powerData) | !isEmpty(fanData)">
    <el-col :span="8">
      <div class="title-bar">
        <div class="tit content-title">모듈 정보</div>
        <span v-if="isTrue(moduleData.isAbnormal)" class="abnormal-message">
          {{ moduleData.abnormalMessage }}
        </span>
      </div>
      <el-table class="box-table" height="120px" :data="isEmpty(moduleData) || isEmpty(moduleData.etcData) ? [] : moduleData.etcData">
        <el-table-column prop="status" label="상태" width="80">
          <template slot-scope="scope">
            <i :class="['fas fa-circle', getHardwareStatusClass('MODULE', scope.row.status)]"></i>
          </template>
        </el-table-column>
        <el-table-column prop="moduleName" label="모듈명" :formatter="formattterForEmptyCheck" />
        <el-table-column prop="serialNumber" label="시리얼 번호" :formatter="formattterForEmptyCheck" />
      </el-table>
    </el-col>
    <el-col :span="8">
      <div class="title-bar">
        <div class="tit content-title">파워 정보</div>
        <span v-if="isTrue(powerData.isAbnormal)" class="abnormal-message">
          {{ powerData.abnormalMessage }}
        </span>
      </div>
      <el-table class="box-table" height="120px" :data="isEmpty(powerData) || isEmpty(powerData.etcData) ? [] : powerData.etcData">
        <el-table-column prop="status" label="상태" width="80">
          <template slot-scope="scope">
            <i :class="['fas fa-circle', getHardwareStatusClass('POWER', scope.row.status)]"></i>
          </template>
        </el-table-column>
        <el-table-column prop="powerDescr" label="파워" :formatter="formattterForEmptyCheck" />
      </el-table>
    </el-col>
    <el-col :span="8">
      <div class="title-bar">
        <div class="tit content-title">팬 정보</div>
        <span v-if="isTrue(fanData.isAbnormal)" class="abnormal-message">
          {{ fanData.abnormalMessage }}
        </span>
      </div>
      <el-table class="box-table" height="120px" :data="isEmpty(fanData) || isEmpty(fanData.etcData) ? [] : fanData.etcData">
        <el-table-column prop="status" label="상태" width="80">
          <template slot-scope="scope">
            <i :class="['fas fa-circle', getHardwareStatusClass('FAN', scope.row.status)]"></i>
          </template>
        </el-table-column>
        <el-table-column prop="fanDescr" label="팬" :formatter="formattterForEmptyCheck" />
      </el-table>
    </el-col>
  </el-row>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { isTrue } from '@/utils/boolean';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { etcInfoDefine } from '../../../../constants/fault-analysis';

export default {
  name: 'WHardwareInfoView',
  props: {
    /**
     * 기타 분석 정보 조회 시 필요한 정보 객체 (동시성 문제 고려하여 하나의 객체로 전달)
     * 1) obj: 분석 대상 장비 정보
     * 2) eventHistData: 분석 이벤트 이력 정보
     * 3) etcInfo: 기타 분석 정보
     * @type {Object}
     */
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      moduleData: {},
      powerData: {},
      fanData: {},
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(to) {
        this.reset();
        if (!isNil(to)) {
          this.setData();
        }
      },
    },
  },
  methods: {
    isTrue,
    isEmpty,
    /**
     * 하드웨어 데이터를 설정한다.
     * @author Ju
     * @return {[type]} [description]
     */
    setData() {
      if (!isEmpty(this.data) && !isEmpty(this.data.etcInfo)) {
        const etcInfo = this.data.etcInfo;
        this.moduleData = isEmpty(etcInfo[etcInfoDefine.NETDEVICE_MODULE]) ? {} : etcInfo[etcInfoDefine.NETDEVICE_MODULE];
        this.powerData = isEmpty(etcInfo[etcInfoDefine.NETDEVICE_POWER]) ? {} : etcInfo[etcInfoDefine.NETDEVICE_POWER];
        this.fanData = isEmpty(etcInfo[etcInfoDefine.NETDEVICE_FAN]) ? {} : etcInfo[etcInfoDefine.NETDEVICE_FAN];
      }
    },
    /**
     * 공백 데이터 처리 formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formattterForEmptyCheck(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 하드웨어 상태에 맞는 클래스를 반환한다.
     * @author Ju
     * @param  {String} type   하드웨어 타입
     * @param  {String} status 하드웨어 상태 값
     * @return {String}        상태에 맞는 클래스명
     */
    getHardwareStatusClass(type, status) {
      return (type === 'MODULE' && status !== 'ok') || (type !== 'MODULE' && status !== 'normal') ? 'state-abnormal' : 'state-normal';
    },
    /**
     * 화면을 초기화한다.
     * @author Ju
     */
    reset() {
      this.moduleData = {};
      this.powerData = {};
      this.fanData = {};
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/EtcInfo/NetdeviceEtcInfoView/HardwareInfoView.vue